"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VISIBILITY_TAB_OPTIONS = void 0;
exports.VISIBILITY_TAB_OPTIONS = [
    { label: 'Coach only', value: '1' },
    { label: 'Everyone', value: '0' },
];
